import MobileDeviceBridgeHandler from "@/mobile-device-bridge/MobileDeviceBridgeHandler";

// Custom handlers
import MobileDeviceBridgeOpenUrlHandler from "@/mobile-device-bridge/custom-handlers/MobileDeviceBridgeOpenUrlHandler";
import MobileDeviceBridgeTakePhotoHandler
    from "@/mobile-device-bridge/custom-handlers/MobileDeviceBridgeTakePhotoHandler";
import MobileDeviceBridgeScanQrHandler from "@/mobile-device-bridge/custom-handlers/MobileDeviceBridgeScanQrHandler";
import MobileDeviceBridgeScanDocumentHandler from "@/mobile-device-bridge/custom-handlers/MobileDeviceBridgeScanDocumentHandler";
import i18n from "@/language/i18n";


export default {
    install(Vue) {

        /**
         * Pushes a notification to registered mobile devices and will open route in mobile WorkApp
         *
         * @param {object} routerOptions        Same that you would defined when use this.$router.push(...).
         * @param {String} routerOptions.name   Name of the route.
         * @param {params} routerOptions.params Params of/for the route.
         * @param {String} title                Title of the Push-Notification.
         * @returns {Promise<any>}
         */
        Vue.prototype.$pushOpenUrlNotification = function (routerOptions, title = i18n.t('MobileDeviceBridge.sentences.openView')) {
            return MobileDeviceBridgeHandler
                .setUp(title, new MobileDeviceBridgeOpenUrlHandler(routerOptions))
                .execute();
        }

        /**
         * Pushes a notification to registered mobile devices and call callback after qr-scan
         *
         * @param {Function} callback
         * @param {Boolean} singleMode       Will scan one URL, otherwise it allows multiple scans
         * @param {String} title task name in app 
         * @param {Object} additionalData    Will add more additional data to message
         * @param {String} customCommand    Will override default command
         * @returns {Promise<any>}
         */
        Vue.prototype.$pushScanQrNotification = function (callback, singleMode, customTitle, additionalData, customCommand) {
            let title = customTitle ? customTitle : singleMode ? i18n.t('MobileDeviceBridge.sentences.scanQRCode') : i18n.t('MobileDeviceBridge.sentences.scanQRCodes')
            return MobileDeviceBridgeHandler
                .setUp(title, new MobileDeviceBridgeScanQrHandler(callback, singleMode, additionalData, customCommand))
                .execute();
        }

        /**
         * Pushes notification to registered mobile devices and will set photo-response into window
         *
         * @param {object} config                   config for callback
         * @param {String} config.type              type of the window. (contained in windowIdentifier - WindowFormModule)
         * @param {String|Number} config.id         id of the window. (contained in windowIdentifier - WindowFormModule)
         * @param {String} config.targetFieldPath   Path where file gets stored.
         * @param {Function} config.customCallback  Will override all previous settings.
         * @param {Function} config.taskPayload     Will add further information to task.
         * @param {Boolean} config.singleMode       Will call takeOnePhoto, otherwise it allows multiple file upload
         * @param {String} title                    Title of the Push-Notification.
         * @returns {Promise<any>}
         */
        Vue.prototype.$pushTakePhotoNotification = function (config, title = i18n.t('MobileDeviceBridge.sentences.takeAPicture')) {
            return MobileDeviceBridgeHandler
                .setUp(title, new MobileDeviceBridgeTakePhotoHandler(config))
                .execute();
        }

          /**
         * Pushes notification to registered mobile devices and will set photo-response into window
         *
         * @param {object} config                   config for callback
         * @param {String} config.type              type of the window. (contained in windowIdentifier - WindowFormModule)
         * @param {String|Number} config.id         id of the window. (contained in windowIdentifier - WindowFormModule)
         * @param {String} config.targetFieldPath   Path where file gets stored.
         * @param {Function} config.customCallback  Will override all previous settings.
         * @param {Function} config.taskPayload     Will add further information to task.
         * @param {String} title                    Title of the Push-Notification.
         * @returns {Promise<any>}
         */
          Vue.prototype.$pushScanDocumentNotification = function (config, title = i18n.t('MobileDeviceBridge.sentences.takeAPicture')) {
            return MobileDeviceBridgeHandler
                .setUp(title, new MobileDeviceBridgeScanDocumentHandler(config))
                .execute();
        }
    }
}
